module.exports = __webpack_public_path__ + "img/phonesad.062ed313.webp";